import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type DeviceStatusType = 'online' | 'warning' | 'error'

export type DeviceStatusIconProps = {
  status: DeviceStatusType
  colorScheme?: 'dark' | 'light'
  size?: number
  className?: string
}

const STATUS_LABELS: Record<DeviceStatusType, string> = {
  online: 'Online',
  warning: 'Warning',
  error: 'Error',
}

const STATUS_COLORS: Record<
  'dark' | 'light',
  Record<DeviceStatusType, { core: string; ring: string }>
> = {
  dark: {
    online: {
      core: tokenVar('colors.device-connection.online'),
      ring: tokenVar('colors.device-connection.online-halo'),
    },
    warning: {
      core: tokenVar('colors.device-connection.warning'),
      ring: tokenVar('colors.device-connection.warning-halo'),
    },
    error: {
      core: tokenVar('colors.device-connection.error'),
      ring: tokenVar('colors.device-connection.error-halo'),
    },
  },
  light: {
    online: {
      core: tokenVar('colors.device-connection.online'),
      ring: tokenVar('colors.light.device-connection.online-halo'),
    },
    warning: {
      core: tokenVar('colors.device-connection.warning'),
      ring: tokenVar('colors.light.device-connection.warning-halo'),
    },
    error: {
      core: tokenVar('colors.device-connection.error'),
      ring: tokenVar('colors.light.device-connection.error-halo'),
    },
  },
}

export const DeviceStatusIcon = ({
  status,
  colorScheme = 'dark',
  size = 24,
  className,
}: DeviceStatusIconProps) => {
  const { core, ring } = STATUS_COLORS[colorScheme][status]
  return (
    <svg
      aria-label={STATUS_LABELS[status]}
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='12' cy='12' r='11' stroke={ring} strokeWidth='2' />
      <circle cx='12' cy='12' fill={core} r='6.46154' />
    </svg>
  )
}
